module.exports = __webpack_public_path__ + "img/football-category-icon-white.b4bd6646.png";